<path
    d="M32.5519 2.59647C29.9819 -0.170446 26.0181 -0.170446 23.4481 2.59647C18.4682 7.95803 11.4925 15 -3.8147e-06 15H56C44.5075 15 37.5318 7.95803 32.5519 2.59647Z"
    fill="white"
/>
